import {
    FailedUploadColumns,
} from 'app/shared-components/SimpleBulkUpload/SimpleBulkUpload.types'
import {
    getErrorColumn,
} from 'app/shared-components/SimpleBulkUpload/SimpleBulkUpload.utils'
import {
    SizeLink,
    TypeLink,
} from 'app/shared-components/SkyNetLink/SkyNetLink.enum'

import SkyNetLink from 'app/shared-components/SkyNetLink'
import {
    LaneFeesFilterRequestResponse,
} from '../LaneFees.types'

const getColumns = (
    {
        l,
        getLaneNumberLink,
        linkStyles,
        getLaneGroupLink,
    }: {
        l: (key: string) => string,
        getLaneNumberLink: (id: number) => string,
        getLaneGroupLink: (laneGroupId: number) => string,
        linkStyles: string,
    },
): FailedUploadColumns<LaneFeesFilterRequestResponse> => {
    return [
        {
            id: 'laneFeesNumber',
            headerProps: {
                children: l('LaneFeesView.lfNumber'),
            },
            mapCellProps: ({
                laneFeesNumber,
                id,
            }) => {
                return {
                    value: laneFeesNumber,
                    link: getLaneNumberLink(id),
                    className: linkStyles,
                    type: TypeLink.EXTERNAL,
                    size: SizeLink.S,
                }
            },
            Cell: SkyNetLink,
            width: '150px',
        },
        {
            id: 'laneGroupNumber',
            headerProps: {
                children: l('LaneFeesView.lgNumber'),
            },
            mapCellProps: ({
                laneGroupId,
                laneGroupNumber,
            }) => {
                return {
                    value: laneGroupNumber,
                    link: getLaneGroupLink(laneGroupId),
                    className: linkStyles,
                    type: TypeLink.EXTERNAL,
                    size: SizeLink.S,
                }
            },
            Cell: SkyNetLink,
            width: '150px',
        },
        getErrorColumn('LaneFees', l),

    ]
}

export default getColumns
